/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Vekn_ConfirmInputs */



/**
* | output |
* | --- |
* | "Trigger a full VEKN member sync now?" |
*
* @param {Admin_Sync_Vekn_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_vekn_confirm = /** @type {((inputs?: Admin_Sync_Vekn_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Vekn_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déclencher une synchronisation complète des membres VEKN maintenant ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Activar una sincronización completa de miembros de VEKN ahora?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Disparar uma sincronização completa de membros do VEKN agora?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avviare una sincronizzazione completa dei membri VEKN ora?")
	return /** @type {LocalizedString} */ ("Trigger a full VEKN member sync now?")
});